import _curry1 from "./internal/_curry1.js";
import _of from "./internal/_of.js";
/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */

var of =
/*#__PURE__*/
_curry1(_of);

export default of;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/of.js
// module id = 1375
// module chunks = 1